import { module } from 'modujs';
import { html } from '../utils/environment';
import * as focusTrap from 'focus-trap';

const CLASS = {
    OPEN: `has-menu-open`,
}

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                'close': 'closeMenu'
            }
        }
    }

    init() {
        this.trap = focusTrap.createFocusTrap(['.c-header', this.el], {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            allowOutsideClick: () => true
        });

        this.closeBind = (e) => {
            if (e.key === "Escape") {
               this.closeMenu();
           }
       }

       document.addEventListener('keyup', this.closeBind)
    }

    toggleMenu() {
        if(html.classList.contains(CLASS.OPEN)) {
            this.closeMenu()
        } else {
            this.openMenu()
        }
    }

    openMenu() {
        html.classList.add(CLASS.OPEN)


        if(!window.isMobile) {
            this.trap?.activate();
        }
    }

    closeMenu() {
        html.classList.remove(CLASS.OPEN)

        if(!window.isMobile) {
            this.trap?.deactivate();
        }
    }

    destroy() {
        super.destroy()
        document.removeEventListener('keyup', this.closeBind)
    }
}
